import { Card, Skeleton } from '@/components/ui';

export function BunkerPricesPreviewSkeleton() {
  return (
    <Card noPadding className="overflow-hidden shadow-sm">
      <div className="divide-y divide-gray-100 dark:divide-dark-700">
        {Array.from({ length: 4 }).map((_, idx) => (
          <div key={idx} className="space-y-1 px-2 py-1.5 sm:px-3 sm:py-2">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0 flex-1 space-y-1">
                <Skeleton className="h-4 w-36 sm:h-5 sm:w-40" />
                <Skeleton className="h-3 w-28 sm:h-3.5" />
              </div>
              <Skeleton className="h-4 w-4 shrink-0 rounded" />
            </div>
            <Skeleton className="h-12 w-full rounded-md sm:h-[3.25rem]" />
          </div>
        ))}
      </div>
    </Card>
  );
}
